import React, {useState, useEffect} from 'react'
import { Modal, } from 'react-bootstrap';


import { useDeleteUserMutation } from './store/ReduxApis';
import toast, { Toaster } from 'react-hot-toast';

function DeleteUser({ email, onDeleteSuccess, refetch }) {

    const [show, setShow] = useState(false);

      const handleClose = () => setShow(false);
      const handleShow = () => setShow(true);
      
     
    const [createPost, responseInfo] = useDeleteUserMutation();

    console.log(responseInfo)

    function refreshPage() {
      setTimeout(() => {
        window.location.reload(false);
      }, 3000)
    }

    const newPost = {
        "email": email
    }

    const deleteUser = () => {
        createPost(newPost)
        handleClose()
        onDeleteSuccess();
    }

    console.log("responseInfoDelete:", responseInfo)

    useEffect(() => {
      if (responseInfo?.data?.status === true) {
          toast(responseInfo?.data?.message)
          refetch()
          // setTimeout(() => (window.location.reload = '/design-2'), 2000)
        //   setTimeout(() => {
        //     window.location.reload();
        // }, 2000);
      } else if(responseInfo?.data?.status === false) {
          toast(responseInfo?.data?.message)
      }

  }, [responseInfo.data])


  return (
      <div>
          <Toaster />
           <i class="fa fa-trash trash" onClick={handleShow}></i>
    <Modal show={show} onHide={handleClose}>
<Modal.Header closeButton>
<Modal.Title>Delete Admin</Modal.Title>
</Modal.Header>
<Modal.Footer>
<button variant="secondary" className='btn btn-primary' onClick={handleClose}>
Close
</button>
<button variant="primary" className='btn btn-danger' onClick={() => deleteUser()}>
Confirm Delete
</button>
</Modal.Footer>
</Modal>
          
    </div>
  )
}

export default DeleteUser